import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { attrs: { dense: "" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [
          _c("app-title", {
            staticClass: "ml-5",
            attrs: { texto: "FORMAÇÃO" },
          }),
        ],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "6" } },
        [
          _c("filtro-formacao-academica", {
            on: { return: (value) => _vm.$emit("formacaoAcademica", value) },
          }),
        ],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "6" } },
        [
          _c("filtro-formacao-complementar", {
            on: { return: (value) => _vm.$emit("formacaoComplementar", value) },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }